export const testimonials = [
  {
    name: 'Dr. Elena Morales',
    role: 'General Dentist',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/593a5c21-9d70-45ac-98eb-e8ae36a75c20.jpg',
    quote: 'The templates were easy to understand from the first case. Having findings, problems, and objectives on separate sheets finally gave my notes a structure I can come back to.',
    tool: 'Most used: Problem-and-Objective Matrix',
  },
  {
    name: 'Dr. Richard Hale',
    role: 'Prosthodontist',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/583f1370-dbd1-42e0-9c9f-3bd81cd722d5.jpg',
    quote: 'The Prosthetic Planning Review fit right into my existing workflow. I use it before every lab conversation to make sure nothing is left undocumented.',
    tool: 'Most used: Prosthetic Planning Review',
  },
  {
    name: 'Dr. Mei Tanaka',
    role: 'General Dentist',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/17d80aad-6ba0-4747-9141-155de4ba0806.jpg',
    quote: 'I used to spread my records across three folders. The one-page case presentation brings everything together and makes team discussions much clearer.',
    tool: 'Most used: One-Page Case Presentation',
  },
  {
    name: 'Dr. Marcus Johnson',
    role: 'Restorative Dentist',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/aa75b146-b173-40f1-a03a-64661ce0034b.jpg',
    quote: 'The visual sequencing sheets help me see dependencies between phases at a glance. It’s a practical toolkit, not another textbook to leave on the shelf.',
    tool: 'Most used: Treatment Sequence Roadmap',
  },
];
